/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const launch = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.857 2H2v12h12v-3.857M8.429 7.57 14 2m0 4.286V2H9.714"
    />
  </svg>
)
export default launch
